const config = {
  googleMaps: {
    bootstrapURLKeys: {
      key: process.env.REACT_APP_WEB_GOOGLE_MAPS_API_KEY!,
    },
  },
};

export default config;
